import ReactMarkdown from 'react-markdown';

import './RenderedMarkdown.scss';

export const RenderedMarkdown = ({ markdownContent }: { markdownContent: string }) => (
  <ReactMarkdown className="workflow__rendered-markdown">{markdownContent}</ReactMarkdown>
);
